import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import './BubbleProgressBar.scss';

interface BubbleProgressBarPropsBase {
  current: number;
  max: number;
  striped?: boolean;
  hideText?: boolean;
  linearFill?: 'ocean' | 'banana' | 'lime';
  icon?: IconProp;
  allowOverfill?: boolean;
  active?: boolean;
  unknown?: boolean;
}

type BubbleProgressBarProps = React.HTMLAttributes<HTMLDivElement> & BubbleProgressBarPropsBase;

export default function BubbleProgressBar(props: BubbleProgressBarProps) {
  const {
    // from component
    current,
    max,
    striped,
    hideText,
    linearFill,
    allowOverfill,
    active,
    icon,
    unknown,
    // from element
    className: propClasses,
    ...rest
  } = props;

  const progress =
    unknown || (max === 0 && current === 0)
      ? 100
      : Math.min(100, Math.max(0, (current / max) * 100));

  const backgroundColor = unknown
    ? 'bg-slate'
    : max === 0 && current === 0
    ? 'bg-smoke'
    : current < 0 || (current > max && !allowOverfill)
    ? 'bg-crimson'
    : linearFill
    ? `bg-${linearFill}`
    : progress <= 33
    ? 'bg-ocean'
    : progress <= 66
    ? 'bg-banana'
    : 'bg-lime';

  const containerClasses = [
    'bubble-progress-bar-container flex items-center space-x-2 whitespace-nowrap',
  ];
  if (propClasses) containerClasses.push(propClasses);

  const classes = ['bubble-progress-bar'];
  if (active) classes.push('bubble-progress-bar-active');

  return (
    <div {...rest} className={containerClasses.join(' ')}>
      {icon && <FontAwesomeIcon icon={icon} size="xs" className="text-smoke" />}
      {!hideText && (
        <span className="progress-text">
          {current}
          <span className="text-slate"> / {unknown ? '?' : max}</span>
        </span>
      )}
      <div className={classes.join(' ')}>
        <div
          className={`progress-indicator ${backgroundColor} ${
            striped ? 'progress-indicator-striped' : ''
          }`}
          style={{ width: `${progress}%`, minWidth: current > 0 ? 'min(100%, 20px)' : '' }}
        />
      </div>
    </div>
  );
}
